const t = (x) => `${x}px`;
export {
  t as withPx
};
//# sourceMappingURL=withPx.mjs.map
